module.exports = __webpack_public_path__ + "img/20200912_130925.4e12b785.jpg";